export default __webpack_public_path__ + "static/media/Molinete.a0cb3a2d.svg";